import { useAuthStore } from '@/store/authStore';
import { useCompetitionContext } from '@/hooks/useCompetitions';
import type { ParticipantStatus } from '@/api/types';

export interface ActiveCompetitionRole {
  competitionId: string | null;
  canManage: boolean;
  isJudge: boolean;
  isParticipant: boolean;
  participantStatus?: ParticipantStatus | null;
  isLoading: boolean;
}

/**
 * The caller's role in the competition currently selected via the
 * competition switcher (store/authStore.ts `activeCompetitionId`). This is
 * the single hook that replaces `hasRole(user, ...)` for anything that used
 * to be a competition-scoped global role (Organizer/Judge/Competitor) -
 * standing now varies per competition, not per account.
 */
export function useActiveCompetitionRole(): ActiveCompetitionRole {
  const competitionId = useAuthStore((s) => s.activeCompetitionId);
  const { data, isLoading } = useCompetitionContext(competitionId ?? undefined);

  return {
    competitionId,
    canManage: data?.canManage ?? false,
    isJudge: data?.isJudge ?? false,
    isParticipant: data?.isParticipant ?? false,
    participantStatus: data?.participantStatus,
    isLoading: Boolean(competitionId) && isLoading,
  };
}
